export enum FileType {
  HTML = 1,
  PDF = 2,
  XLSX = 3,
  CSV = 4,
  KML = 5,
}
